

<template>
	<a class="hotspot" @click="onClick" :style="style">
	</a>
</template>

<script>

import { EventBus } from '@/common/eventbus.js'
import { store } from '@/store'
import { mapState } from 'vuex'

export default {
	store,
	props: ['x', 'y', 'link'],
	data: () => {
		return {
		}
	},
	computed: {
		...mapState('globals', ['app']),
		...mapState('settings', ['presets']),
		style: function () 	{
			return {
				top: this.y + `%`,
				left: this.x + `%`
			}
		}
	},

	mounted() {
	},

	methods: {
		
		onClick( event ) {
			EventBus.$emit('hotspot-clicked', this.createEventParameters( event ) );
		},

		createEventParameters( event ) {
			return Object.assign({
				link: this.link,
				$el: this.$el,
				originalEvent: event,
			});
		}
	}

}
</script>

<style scoped lang="scss">
	.hotspot {
		position: absolute;
		width: 30px;
		height: 30px;
		transform: translate( -50%, -50% );
		cursor: pointer;
		&:after {
			content: '';
			@include position( absolute, 50% auto auto 50%, 10, 40px, 40px );
			//background: rgba(255,128,0,0.5);
			transform-origin: left top;
			border-radius: 100%;
			box-sizing: border-box;
			border: 1px solid rgba(255,128,0,0);
			@include animation( pulse, 1500ms, 0, cubic-bezier(0.08, 0.71, 0.61, 0.99), infinite, forwards);
		}
		@media ($max-device-width-md) {
			width: 10px;
			height: 10px;
			&:after {
				width: 20px;
				height: 20px;
				@include animation( pulse-mobile, 1500ms, 0, cubic-bezier(0.08, 0.71, 0.61, 0.99), infinite, forwards);
			}
		}
	}

	@keyframes pulse {
		0% { 
			transform: scale(0) translate( -50%, -50% );
			border: 40px solid rgba(255,128,0,0);
			opacity: 0;
		}
		50% { 
			border: 10px solid rgba(255,128,0,0.6);
			opacity: 1;
		}
		100% { 
			transform: scale(1) translate( -50%, -50% );
			border: 0 solid rgba(255,128,0,0);
			opacity: 0.5;
		}
	}
	
	@keyframes pulse-mobile {
		0% { 
			transform: scale(0) translate( -50%, -50% );
			border: 10px solid rgba(255,128,0,0);
			opacity: 0;
		}
		50% { 
			border: 5px solid rgba(255,128,0,0.6);
			opacity: 1;
		}
		100% { 
			transform: scale(1) translate( -50%, -50% );
			border: 0 solid rgba(255,128,0,0);
			opacity: 0.5;
		}
	}

</style>
